let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cFtyz")).then(() => parcelRequire('l8BRw'));